/*
  PYKAS BUYBOX JS v4 (Addendum Section-Architektur v2 — inline Kaufblock, kein Modal)
  Zweck: (1) Staffel/Options-Auswahl mit Live-Umrechnung aller Cards (Preis, Streichpreis,
             €/kg, Spar-%), ungültige Kombis disabled, Auto-Fallback
         (2) Menge → Zwischensumme; Bestandsanzeige NUR bei aktiviertem Gate + echtem Bestand
         (3) Kaufart Abo/Einmalkauf (Selling-Plan-Input aktiv/inaktiv)
         (4) ATC via /cart/add.js mit Dawn-Drawer-Refresh, Fallback /cart
         (5) Order-Bump/Extras "+ Dazu"
         (6) Sticky Buy Bar: Varianten-Dropdown synchron in beide Richtungen, ATC direkt
  DOM-Hooks: [data-pykas-buybox], [data-pykas-variants], [data-pykas-sticky-buybar],
             [data-pykas-qty], [data-pykas-bestand], [data-pykas-kaufart], [data-pykas-selling-plan],
  Ohne JS: natives Form-Submit auf /cart/add.
*/

(function () {
  'use strict';

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2) + ' €';
    }
  }

  function refreshDrawer(parsedState) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && parsedState) {
      // Dawns renderContents entfernt is-empty nur vom inneren .drawer__inner —
      // das <cart-drawer>-Wurzelelement ueberlebt den innerHTML-Tausch samt
      // veralteter Klasse, und Dawns CSS versteckt daran Kopf und Zeilen
      // (Pauls Screenshot 20.08.: leerer Drawer trotz Artikel). Ein Add macht
      // den Warenkorb immer nicht-leer, also darf die Klasse hier weg.
      drawer.classList.remove('is-empty');
      drawer.renderContents(parsedState);
    }
    document.dispatchEvent(new CustomEvent('pykas:cart-updated'));
  }

  function initBuybox(root) {
    var hasNotifiedOnce = false;
    var dataEl = root.querySelector('[data-pykas-variants]');
    if (!dataEl) return null;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (error) {
      console.error('[pykas-buybox] Varianten-JSON unlesbar', error);
      return null;
    }

    var mengeIndex = parseInt(root.dataset.mengeIndex, 10) || 0;
    var altIndex = parseInt(root.dataset.haerteIndex, 10) || 0;
    var freeCents = parseInt(root.dataset.freeCents, 10) || 0;
    var giftCents = parseInt(root.dataset.giftCents, 10) || 0;
    var currency = root.dataset.currency || 'EUR';
    var bestandAnzeigen = root.dataset.bestandAnzeigen === 'true';

    // Aktionsrabatt (Pauls Auftrag 20.08.: Streichpreis ueberall). Reine
    // ANZEIGE — der echte Abzug kommt aus Shopifys automatischem Rabatt.
    // Ohne das hier zeigten CTA und Preis-Anker weiter den vollen Preis,
    // waehrend Karten und Panel schon reduziert waren.
    var aktionProzent = parseFloat(root.dataset.aktionProzent) || 0;
    var aktionFaktor = aktionProzent > 0 && aktionProzent < 100 ? (100 - aktionProzent) / 100 : 1;
    function aktionsPreis(cents) {
      return aktionFaktor === 1 ? cents : Math.round(cents * aktionFaktor);
    }


    var idInput = root.querySelector('[data-pykas-variant-id]');
    var qtyInput = root.querySelector('[data-pykas-qty]');
    var bestandEl = root.querySelector('[data-pykas-bestand]');

    function qty() {
      var value = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      return value > 0 ? value : 1;
    }

    function selectedValue(name) {
      var input = root.querySelector('input[name="' + name + '"]:checked');
      return input ? input.value : null;
    }

    function optionOf(variant, index) {
      if (index === 1) return variant.option1;
      if (index === 2) return variant.option2;
      if (index === 3) return variant.option3;
      return null;
    }

    function matchFor(mengeValue, altValue) {
      return (
        variants.find(function (variant) {
          var mengeOk = mengeIndex === 0 ? variant.title === mengeValue : optionOf(variant, mengeIndex) === mengeValue;
          var altOk = altIndex === 0 || !altValue || optionOf(variant, altIndex) === altValue;
          return mengeOk && altOk;
        }) || null
      );
    }

    /* Pfeile fuer "Passt dazu". Dieselbe Mechanik wie bei den Startseiten-
       Slidern, mit einem Unterschied: die Liste liegt im Kaufpanel, das per
       hidden versteckt startet. Solange es zu ist, sind clientWidth und
       scrollWidth 0 — die Endlagen-Rechnung liefe damit ins Leere und der
       rechte Pfeil stuende sofort auf "aus". Ein ResizeObserver rechnet neu,
       sobald die Liste beim Oeffnen echte Masse bekommt. */
    function initBumpPfeile() {
      var liste = root.querySelector('[data-pykas-bump-liste]');
      var pfeile = root.querySelector('[data-pykas-bump-pfeile]');
      if (!liste || !pfeile) return;
      var knoepfe = pfeile.querySelectorAll('[data-pykas-bump-slide]');
      if (knoepfe.length < 2) return;

      knoepfe.forEach(function (knopf) {
        knopf.addEventListener('click', function () {
          var richtung = parseInt(knopf.dataset.pykasBumpSlide, 10);
          liste.scrollBy({ left: liste.clientWidth * 0.85 * richtung, behavior: 'smooth' });
        });
      });

      function endlagen() {
        // Bei geschlossenem Panel nichts anfassen: 0 breit hiesse sonst
        // "am Ende angekommen" und beide Pfeile waeren grau.
        if (!liste.clientWidth) return;
        var ende = liste.scrollWidth - liste.clientWidth - 4;
        knoepfe[0].classList.toggle('is-aus', liste.scrollLeft <= 4);
        knoepfe[1].classList.toggle('is-aus', liste.scrollLeft >= ende);
      }

      liste.addEventListener('scroll', endlagen, { passive: true });
      window.addEventListener('resize', endlagen);
      if ('ResizeObserver' in window) new ResizeObserver(endlagen).observe(liste);
      endlagen();
    }

    initBumpPfeile();

    function resolveVariant() {
      var menge = selectedValue('pykas-menge');
      var alt = selectedValue('pykas-haerte');
      // Produkte mit genau EINER Variante rendern kein Mengen-Wahlfeld: das
      // Liquid-Gate bb_zeige_staffel verlangt entweder mehrere Optionswerte
      // oder mehrere Varianten. selectedValue liefert dann null — und
      // matchFor vergleicht bei mengeIndex 0 variant.title mit null, findet
      // also nie etwas. updateAtc bekam null, hielt das fuer "nicht
      // verfuegbar" und schrieb "Ausverkauft" ueber den vom Server korrekt
      // gerenderten Knopf (Pauls Befund 20.08., Maracujaner-Lockstoff mit
      // 999 auf Lager). Betrifft jedes einvariantige Produkt: Lockstoffe,
      // Knete, Zubehoer, Bundles, Gutscheine.
      // Ohne gerendertes Feld gibt es nichts zu waehlen, also nicht danach
      // filtern.
      if (menge === null && !root.querySelector('input[name="pykas-menge"]')) {
        if (alt !== null && altIndex > 0) {
          return (
            variants.find(function (variant) {
              return optionOf(variant, altIndex) === alt;
            }) || null
          );
        }
        return variants[0] || null;
      }
      return matchFor(menge, alt);
    }

    // Pill-Wechsel rechnet jede Mengen-Card live um (Preis, Streichpreis, €/kg,
    // Vorteil je Kilo). Der Vorteil kommt bewusst NICHT aus compare_at_price:
    // das ist im Katalog ueberall gleich price, jedes Prozent waere erfunden.
    // Stattdessen die echte Mengendegression gegen die teuerste Stufe je Kilo.
    function updateCards() {
      var alt = selectedValue('pykas-haerte');

      root.querySelectorAll('[data-pykas-card]').forEach(function (card) {
        var match = matchFor(card.dataset.pykasCard, alt);
        var input = card.querySelector('input[data-pykas-menge]');
        var priceWrap = card.querySelector('[data-pykas-card-price]');
        var available = Boolean(match && match.available);

        card.classList.toggle('is-disabled', !match);
        if (input) input.disabled = !match;

        if (match && priceWrap) {
          var html = '<span class="pykas-price__current">' + formatMoney(aktionsPreis(match.price), currency) + '</span>';
          if (aktionFaktor !== 1) {
            html += ' <s class="pykas-compare-at">' + formatMoney(match.price, currency) + '</s>';
          } else if (match.compare_at_price > match.price) {
            html += ' <s class="pykas-compare-at">' + formatMoney(match.compare_at_price, currency) + '</s>';
          }
          if (match.gewicht > 0) {
            html +=
              ' <span class="pykas-price-kg">(' +
              formatMoney(Math.round(match.price / match.gewicht), currency) +
              '/kg)</span>';
          }
          if (!available) {
            html += ' <span class="pykas-price-kg">— ausverkauft</span>';
          }
          priceWrap.innerHTML = html;
        }
        // Kein Degressions-Abzeichen mehr (Pauls Vorgabe 20.08.): neben dem
        // laufenden 20-%-Aktionsrabatt standen zwei Prozentzahlen mit
        // verschiedener Bedeutung auf derselben Karte. Der Kilopreis in
        // Klammern traegt den Mengenvorteil eindeutig.
      });
    }

    function ensureValidSelection() {
      if (resolveVariant()) return;
      var firstEnabled = root.querySelector('input[data-pykas-menge]:not(:disabled)');
      if (firstEnabled) firstEnabled.checked = true;
    }

    function updateSummary(variant) {
      if (!variant) return;
      var mengeEl = root.querySelector('[data-pykas-summary-menge]');
      var priceEl = root.querySelector('[data-pykas-summary-price]');
      var compareEl = root.querySelector('[data-pykas-summary-compare]');
      var subtotalEl = root.querySelector('[data-pykas-summary-subtotal]');
      var shippingEl = root.querySelector('[data-pykas-summary-shipping]');
      var savingsEl = root.querySelector('[data-pykas-summary-savings]');
      var giftLine = root.querySelector('[data-pykas-gift-line]');
      var subtotal = aktionsPreis(variant.price) * qty();

      if (mengeEl) mengeEl.textContent = variant.title;
      if (priceEl) priceEl.textContent = formatMoney(variant.price, currency);
      if (subtotalEl) subtotalEl.textContent = formatMoney(subtotal, currency);

      var hasCompare = variant.compare_at_price > variant.price;
      if (compareEl) {
        compareEl.hidden = !hasCompare;
        compareEl.textContent = hasCompare ? 'statt ' + formatMoney(variant.compare_at_price, currency) : '';
      }
      if (savingsEl) {
        savingsEl.textContent = hasCompare
          ? formatMoney((variant.compare_at_price - variant.price) * qty(), currency)
          : '—';
      }
      if (shippingEl) {
        shippingEl.textContent = freeCents > 0 && subtotal >= freeCents ? 'Gratis' : 'wird im Checkout berechnet';
      }
      if (giftLine) {
        giftLine.hidden = !(giftCents > 0 && subtotal >= giftCents);
      }
    }

    // Bestandsanzeige — nur bei aktiviertem Gate UND echtem, verwaltetem Bestand
    function updateBestand(variant) {
      if (!bestandEl) return;
      var show = bestandAnzeigen && variant && variant.managed && variant.inventory > 0;
      bestandEl.hidden = !show;
      if (show) bestandEl.textContent = 'Noch ' + variant.inventory + ' auf Lager';
    }

    function updateCtaPrices(variant) {
      var subtotal = variant ? aktionsPreis(variant.price) * qty() : 0;
      root.querySelectorAll('[data-pykas-atc-price]').forEach(function (el) {
        el.textContent = variant ? formatMoney(subtotal, currency) : '';
      });
      root.querySelectorAll('[data-pykas-atc-compare]').forEach(function (el) {
        // Aktion schlaegt echten compare_at: waeren beide sichtbar, stuenden
        // zwei durchgestrichene Preise nebeneinander.
        var zeigeAktion = variant && aktionFaktor !== 1;
        var hasCompare = variant && variant.compare_at_price > variant.price;
        el.hidden = !(zeigeAktion || hasCompare);
        if (zeigeAktion) {
          el.textContent = formatMoney(variant.price * qty(), currency);
        } else if (hasCompare) {
          el.textContent = formatMoney(variant.compare_at_price * qty(), currency);
        } else {
          el.textContent = '';
        }
      });
    }

    // Preis-Anker oben in der Buy Box — Preis, Streichpreis, Ersparnis, kg-Preis
    function updateAnker(variant) {
      var priceEls = root.querySelectorAll('[data-pykas-anker-price], [data-pykas-anker-price2]');
      if (!priceEls.length) return;
      var compareEl = root.querySelector('[data-pykas-anker-compare]');
      var saveEl = root.querySelector('[data-pykas-anker-save]');
      var kgEl = root.querySelector('[data-pykas-anker-kg]');
      var hasCompare = Boolean(variant && variant.compare_at_price > variant.price);

      var zeigeAktion = Boolean(variant) && aktionFaktor !== 1;
      var preisText = variant ? formatMoney(aktionsPreis(variant.price), currency) : '';
      Array.prototype.forEach.call(priceEls, function (el) {
        el.textContent = preisText;
      });
      if (compareEl) {
        compareEl.hidden = !(zeigeAktion || hasCompare);
        if (zeigeAktion) {
          compareEl.textContent = formatMoney(variant.price, currency);
        } else if (hasCompare) {
          compareEl.textContent = formatMoney(variant.compare_at_price, currency);
        } else {
          compareEl.textContent = '';
        }
      }
      if (saveEl) {
        saveEl.hidden = !(zeigeAktion || hasCompare);
        if (zeigeAktion) {
          saveEl.textContent = 'Spar ' + Math.round(aktionProzent) + ' %';
        } else if (hasCompare) {
          var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          saveEl.textContent = 'Spar ' + pct + ' %';
        }
      }
      if (kgEl) {
        // Grundpreis vom NORMALEN Preis (Pauls Vorgabe 20.08.) — der
        // Artikelpreis bleibt, der Abzug passiert als Rabatt im Warenkorb.
        kgEl.textContent =
          variant && variant.gewicht > 0
            ? formatMoney(Math.round(variant.price / variant.gewicht), currency) + '/kg'
            : '';
      }
    }

    // Abo-Rechnungstabelle (PetLab-Muster): Preis/Streichpreis/Gesamt/Ersparnis live
    function updateAboTabelle(variant) {
      var priceEl = root.querySelector('[data-pykas-abo-price]');
      if (!priceEl) return;
      var compareEl = root.querySelector('[data-pykas-abo-compare]');
      var totalEl = root.querySelector('[data-pykas-abo-total]');
      var savingEl = root.querySelector('[data-pykas-abo-saving]');
      var hasCompare = Boolean(variant && variant.compare_at_price > variant.price);
      priceEl.textContent = variant ? formatMoney(variant.price, currency) : '';
      if (compareEl) {
        compareEl.hidden = !hasCompare;
        compareEl.textContent = hasCompare ? formatMoney(variant.compare_at_price, currency) : '';
      }
      if (totalEl) totalEl.textContent = variant ? formatMoney(variant.price, currency) : '';
      if (savingEl) {
        savingEl.hidden = !hasCompare;
        if (hasCompare)
          savingEl.textContent = 'Du sparst: ' + formatMoney(variant.compare_at_price - variant.price, currency);
      }
    }

    function updateCardStyles() {
      root
        .querySelectorAll('.pykas-buybox__card, .pykas-modal__pill, .pykas-buybox__abo, .pykas-buybox__einmal')
        .forEach(function (card) {
          var input = card.querySelector('input[type="radio"]');
          card.classList.toggle('is-selected', Boolean(input && input.checked));
        });
    }

    function updateAtc(variant) {
      var available = Boolean(variant && variant.available);
      root.querySelectorAll('[data-pykas-atc]').forEach(function (button) {
        button.disabled = !available;
        var label = button.querySelector('[data-pykas-atc-label]');
        if (label) label.textContent = available ? button.dataset.pykasAtcText || label.textContent : 'Ausverkauft';
      });
    }

    // Kaufart Abo/Einmalkauf: Selling-Plan-Input nur bei Abo aktiv
    function updateKaufart() {
      var kaufart = selectedValue('pykas-kaufart');
      root.querySelectorAll('[data-pykas-selling-plan]').forEach(function (input) {
        input.disabled = kaufart === 'einmal';
      });
    }

    function notify(variant) {
      document.dispatchEvent(
        new CustomEvent('pykas:variant', {
          detail: {
            initial: !hasNotifiedOnce,
            id: variant ? variant.id : null,
            price: variant ? variant.price : 0,
            compareAtPrice: variant ? variant.compare_at_price : 0,
            gewicht: variant ? variant.gewicht : 0,
            title: variant ? variant.title : '',
            available: Boolean(variant && variant.available),
            currency: currency,
          },
        }),
      );
    }

    function onSelectionChange() {
      updateCards();
      ensureValidSelection();
      var variant = resolveVariant();
      if (variant && idInput) idInput.value = variant.id;
      updateSummary(variant);
      updateBestand(variant);
      updateCtaPrices(variant);
      updateAnker(variant);
      updateAboTabelle(variant);
      updateCardStyles();
      updateAtc(variant);
      updateKaufart();
      notify(variant);
    }

    root.querySelectorAll('[data-pykas-menge], [data-pykas-haerte], [data-pykas-kaufart]').forEach(function (input) {
      input.addEventListener('change', onSelectionChange);
    });
    if (qtyInput) qtyInput.addEventListener('input', onSelectionChange);

    // Mengen-Stepper im Panel-Fuss (Pauls Auftrag 21.08.): +/- schreiben ins
    // quantity-Feld und feuern input — der Listener darueber rechnet damit
    // die CTA-Preise automatisch mal Menge.
    root.querySelectorAll('[data-pykas-qty-step]').forEach(function (knopf) {
      knopf.addEventListener('click', function () {
        if (!qtyInput) return;
        var schritt = parseInt(knopf.dataset.pykasQtyStep, 10) || 1;
        var wert = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = String(Math.max(1, wert + schritt));
        qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      });
    });

    // Externe Variantenwahl (Sticky-Dropdown): setzt Radios passend zur Varianten-ID
    root.addEventListener('pykas:select-variant', function (event) {
      var target = variants.find(function (variant) {
        return variant.id === event.detail.id;
      });
      if (!target) return;
      if (mengeIndex > 0) {
        var mengeValue = optionOf(target, mengeIndex);
        var mengeInput = root.querySelector('input[data-pykas-menge][value="' + CSS.escape(mengeValue) + '"]');
        if (mengeInput) mengeInput.checked = true;
      }
      if (altIndex > 0) {
        var altValue = optionOf(target, altIndex);
        var altInput = root.querySelector('input[data-pykas-haerte][value="' + CSS.escape(altValue) + '"]');
        if (altInput) altInput.checked = true;
      }
      onSelectionChange();
    });

    // ATC: fetch auf /cart/add.js + Drawer-Refresh, Fallback /cart bzw. natives Submit
    root.querySelectorAll('[data-pykas-atc-form]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        // Leeres oder unsinniges Mengenfeld vor dem Senden auf den geklammerten
        // Wert setzen — FormData(form) uebernimmt sonst den Rohtext.
        if (qtyInput) qtyInput.value = String(qty());
        var body = new FormData(form);
        var atcVariant = resolveVariant();
        var atcQty = qty();
        body.append('sections', 'cart-drawer,cart-icon-bubble');
        body.append('sections_url', window.location.pathname);

        fetch(form.action + '.js', {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: body,
        })
          .then(function (response) {
            if (!response.ok) throw new Error('ATC HTTP ' + response.status);
            return response.json();
          })
          .then(function (parsedState) {
            document.dispatchEvent(
              new CustomEvent('pykas:atc-success', {
                detail: {
                  variantId: atcVariant ? atcVariant.id : null,
                  quantity: atcQty,
                  price: atcVariant ? atcVariant.price : null,
                  currency: currency,
                  source: 'buybox',
                },
              }),
            );
            if (document.querySelector('cart-drawer')) {
              refreshDrawer(parsedState);
            } else {
              window.location.href = '/cart';
            }
          })
          .catch(function (error) {
            console.error('[pykas-buybox] ATC fehlgeschlagen, Fallback auf natives Submit', error);
            form.submit();
          });
      });
    });

    // Order-Bump / Extras "+ Dazu"
    root.querySelectorAll('[data-pykas-extra-add]').forEach(function (button) {
      button.addEventListener('click', function () {
        var variantId = parseInt(button.dataset.variantId, 10);
        if (!variantId) return;
        button.disabled = true;
        var body = new FormData();
        body.append('id', String(variantId));
        body.append('quantity', '1');
        body.append('sections', 'cart-drawer,cart-icon-bubble');
        body.append('sections_url', window.location.pathname);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: body,
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Extra-ATC HTTP ' + response.status);
            return response.json();
          })
          .then(function (parsedState) {
            document.dispatchEvent(
              new CustomEvent('pykas:atc-success', {
                detail: {
                  variantId: variantId,
                  quantity: 1,
                  source: 'extra',
                },
              }),
            );
            button.textContent = '✓ Drin';
            refreshDrawer(parsedState);
          })
          .catch(function (error) {
            console.error('[pykas-buybox] Extra-ATC fehlgeschlagen', error);
            button.disabled = false;
          });
      });
    });

    // Varianten-Dropdown der Extras-Karten (Pauls Auftrag 21.08.): der
    // Wechsel schreibt die Varianten-ID auf den "+ Dazu"-Button um und
    // tauscht die vorformatierten Preise aus den option-data-Attributen
    // ein. Gerechnet wird hier nichts — die Betraege kommen fertig aus
    // Liquid, derselbe Weg wie beim Rest der Aktionsanzeige.
    root.querySelectorAll('[data-pykas-extra-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var option = select.options[select.selectedIndex];
        var card = select.closest('.pykas-modal-extra');
        if (!option || !card) return;
        var addButton = card.querySelector('[data-pykas-extra-add]');
        if (addButton) {
          addButton.dataset.variantId = option.value;
          // Nach einem "✓ Drin" wieder kaufbar: eine ANDERE Variante ist
          // ein neuer Wunsch, kein Doppelkauf.
          addButton.disabled = false;
          addButton.textContent = '+ Dazu';
        }
        var jetzt = card.querySelector('.pykas-preis__jetzt');
        if (jetzt && option.dataset.preis) jetzt.textContent = option.dataset.preis;
        var alt = card.querySelector('.pykas-compare-at');
        if (alt) {
          if (option.dataset.alt) {
            alt.textContent = option.dataset.alt;
            alt.hidden = false;
          } else {
            alt.hidden = true;
          }
        }
      });
    });

    onSelectionChange();
    hasNotifiedOnce = true;
    return root;
  }

  function initStickyBar(buyboxRoot) {
    var bar = document.querySelector('[data-pykas-sticky-buybar]');
    if (!bar || !buyboxRoot) return;
    var button = bar.querySelector('[data-pykas-sticky-button]');

    /* Der Editor ersetzt die Leiste bei jeder Einstellungsaenderung — die per JS
       gesetzte is-visible-Klasse ist dann weg und die Basis display:none greift.
       Genau so "verschwand" der CTA beim Verstellen der Schriftgroesse. Deshalb
       Sichtbarkeit bei JEDEM Init zuerst, danach die Wache gegen doppelte
       Listener fuer den Fall, dass nur eine ANDERE Section neu gerendert wurde. */
    bar.classList.add('is-visible');
    if (bar.dataset.pykasInit === '1') return;
    bar.dataset.pykasInit = '1';

    // Ausverkaufte Variante sperrt den einzigen Kauf-Button der Seite
    document.addEventListener('pykas:variant', function (event) {
      if (button && event.detail) button.disabled = !event.detail.available;
    });

    /* Dauerhaft sichtbar: Der Kaufteil liegt hinter dem Panel, diese Leiste ist der
       einzige Zugang dorthin — sie darf nicht erst beim Wegscrollen erscheinen. */
    bar.classList.add('is-visible');

    /* Fallback fuer Templates ohne Kaufpanel: direkt absenden. Existiert ein Panel,
       faengt dessen capture-Listener den Klick vorher ab und oeffnet es stattdessen. */
    if (button) {
      button.addEventListener('click', function () {
        var form = buyboxRoot.querySelector('[data-pykas-atc-form]');
        if (form) form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }
  }

  function init() {
    var buyboxRoot = null;
    document.querySelectorAll('[data-pykas-buybox]').forEach(function (root) {
      /* shopify:section:load feuert auch, wenn nur eine ANDERE Section neu
         gerendert wurde. Ohne Wache bekaeme die unveraenderte Buybox dann bei
         jedem Editor-Schritt einen weiteren Satz Listener — ein Klick auf den
         CTA wuerde mehrfach in den Warenkorb legen. */
      if (root.dataset.pykasInit === '1') {
        buyboxRoot = root;
        return;
      }
      var initialisiert = initBuybox(root);
      if (initialisiert) {
        root.dataset.pykasInit = '1';
        buyboxRoot = initialisiert;
      }
    });
    initStickyBar(buyboxRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Der Theme-Editor ersetzt bei JEDER Einstellungsaenderung das komplette
     Section-DOM (shopify:section:load). Alle Init-Bloecke liefen bisher genau
     einmal bei DOMContentLoaded — danach waren Preise, Optionen und die
     '+ Dazu'-Buttons im Editor tot. */
  document.addEventListener('shopify:section:load', init);
})();

/* ---------- Tab-Box in der Buybox ----------
   Panels sind serverseitig gerendert und nur per hidden versteckt: ohne JS
   bleibt der erste Tab sichtbar, der Inhalt der anderen steht im Quelltext. */
(function () {
  function initTabbox() {
    document.querySelectorAll('[data-pykas-tabbox]').forEach(function (box) {
      if (box.dataset.pykasInit === '1') return;
      box.dataset.pykasInit = '1';
      var tabs = Array.prototype.slice.call(box.querySelectorAll('[data-pykas-tab]'));
      var panels = Array.prototype.slice.call(box.querySelectorAll('[data-pykas-panel]'));
      if (tabs.length !== panels.length) return;

      function zeige(index) {
        tabs.forEach(function (tab, i) {
          var aktiv = i === index;
          tab.classList.toggle('is-aktiv', aktiv);
          tab.setAttribute('aria-selected', aktiv ? 'true' : 'false');
          tab.setAttribute('tabindex', aktiv ? '0' : '-1');
          panels[i].hidden = !aktiv;
        });
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          zeige(i);
        });
        tab.addEventListener('keydown', function (e) {
          var schritt = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!schritt) return;
          e.preventDefault();
          var ziel = (i + schritt + tabs.length) % tabs.length;
          zeige(ziel);
          tabs[ziel].focus();
        });
      });
      zeige(0);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTabbox);
  } else {
    initTabbox();
  }
  document.addEventListener('shopify:section:load', initTabbox);
})();

/* ---------- Kaufpanel (PetLab-Muster: Kaufteil hinter einem Button) ----------
   Ohne JS bleibt das Panel ein normaler Abschnitt der Seite — der Kaufweg
   funktioniert immer. Erst hier wird daraus ein Overlay. Preis und Grundpreis
   stehen unabhaengig davon dauerhaft in der Sticky-Leiste. */
(function () {
  function initKaufpanel() {
    var panel = document.querySelector('[data-pykas-kaufpanel]');
    if (!panel) return;
    if (panel.dataset.pykasInit === '1') return;
    panel.dataset.pykasInit = '1';
    var oeffner = document.querySelector('[data-pykas-kaufpanel-open]');
    var schliesser = panel.querySelector('[data-pykas-kaufpanel-close]');
    var box = panel.querySelector('.pykas-kaufpanel__box');
    var zuletztFokussiert = null;

    panel.classList.add('is-overlay');
    panel.hidden = true;
    if (oeffner) oeffner.hidden = false;

    function fokussierbare() {
      return Array.prototype.slice
        .call(
          panel.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea, [tabindex]:not([tabindex="-1"])',
          ),
        )
        .filter(function (el) {
          return el.offsetParent !== null;
        });
    }

    /* Die Sticky-Leiste ist der Oeffner des Panels — sobald es offen ist, hat sie
       keine Aufgabe mehr und lag bisher sichtbar ueber dem Overlay. Ueber die
       Klasse statt ueber [hidden], weil .is-visible { display:flex } sonst
       gewinnt. */
    var stickyLeiste = document.querySelector('[data-pykas-sticky-buybar]');

    function oeffnen() {
      zuletztFokussiert = document.activeElement;
      panel.hidden = false;
      document.body.style.overflow = 'hidden';
      if (stickyLeiste) stickyLeiste.classList.remove('is-visible');
      var erste = fokussierbare()[0];
      if (erste) erste.focus();
    }

    function schliessen() {
      panel.hidden = true;
      document.body.style.overflow = '';
      if (stickyLeiste) stickyLeiste.classList.add('is-visible');
      if (zuletztFokussiert && zuletztFokussiert.focus) zuletztFokussiert.focus();
    }

    if (oeffner) oeffner.addEventListener('click', oeffnen);
    if (schliesser) schliesser.addEventListener('click', schliessen);

    /* PetLab-Wechsel: ein erfolgreicher ATC aus dem Panel (grosser CTA oder
       '+ Dazu' bei den Extras) schliesst das Panel — der Cart-Drawer oeffnet
       sich direkt danach selbst (Dawns renderContents). Ohne diese Zeile blieb
       das Panel samt Abdunkelung unter dem Drawer offen liegen. Reihenfolge
       passt: das Event feuert VOR dem Drawer-Refresh, schliessen() gibt den
       Fokus zurueck, dann uebernimmt der Drawer ihn mit seiner Fokus-Falle. */
    document.addEventListener('pykas:atc-success', function () {
      if (!panel.hidden) schliessen();
    });
    panel.addEventListener('click', function (e) {
      if (e.target === panel) schliessen();
    });

    document.addEventListener('keydown', function (e) {
      if (panel.hidden) return;
      if (e.key === 'Escape') {
        schliessen();
        return;
      }
      if (e.key !== 'Tab') return;
      var liste = fokussierbare();
      if (!liste.length) return;
      var erste = liste[0],
        letzte = liste[liste.length - 1];
      if (e.shiftKey && document.activeElement === erste) {
        e.preventDefault();
        letzte.focus();
      } else if (!e.shiftKey && document.activeElement === letzte) {
        e.preventDefault();
        erste.focus();
      }
    });

    /* Die Sticky-Leiste kauft nicht mehr direkt, sondern oeffnet das Panel —
       so faellt die Mengen- und Durchmesserwahl nie unter den Tisch. */
    var sticky = document.querySelector('[data-pykas-sticky-button]');
    if (sticky) {
      sticky.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          oeffnen();
        },
        true,
      );
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKaufpanel);
  } else {
    initKaufpanel();
  }
  /* Nach einem Editor-Reload stand das Panel als Inline-Block OHNE Hintergrund
     in der Seite: is-overlay und hidden setzt erst dieses Init. Alte
     document-Listener der vorigen Instanz laufen ins Leere — im Editor
     unschaedlich, im Storefront gibt es keine section:load-Events. */
  document.addEventListener('shopify:section:load', initKaufpanel);
})();
